import { useRef, useEffect } from "react";

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const highlightTextInHtml = (html, highlights) => {
  if (!highlights || highlights.length === 0) return html;

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Prepare valid highlights
  const validHighlights = highlights.filter((h) => h && h.trim()).map(escapeRegExp);

  if (validHighlights.length === 0) return html;

  const regex = new RegExp(`(${validHighlights.join("|")})`, "gi");
  const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);

  const textNodes = [];
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach((node) => {
    const parent = node.parentNode;
    const text = node.nodeValue;
    let lastIndex = 0;
    const fragments = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
      // Text before match
      if (match.index > lastIndex) {
        fragments.push(document.createTextNode(text.substring(lastIndex, match.index)));
      }

      // Highlighted match
      const span = document.createElement("span");
      span.className = "bg-[#f7ec76]";
      span.textContent = match[0];
      fragments.push(span);

      lastIndex = match.index + match[0].length;
    }

    // Remaining text after last match
    if (lastIndex < text.length) {
      fragments.push(document.createTextNode(text.substring(lastIndex)));
    }

    // Replace original node if we have matches
    if (fragments.length > 0) {
      const wrapper = document.createDocumentFragment();
      fragments.forEach((frag) => wrapper.appendChild(frag));
      parent.replaceChild(wrapper, node);
    }
  });

  return tempDiv.innerHTML;
};

const HighlightedParagraph = ({ paragraph, searchTerm, filterValue, className, ...rest }) => {
  const paragraphRef = useRef(null);
  const highlights = [];

  if (searchTerm) highlights.push(searchTerm);
  if (filterValue) highlights.push(filterValue.toString());

  useEffect(() => {
    if (paragraphRef.current && typeof paragraph === "string") {
      paragraphRef.current.innerHTML = highlightTextInHtml(
        paragraph,
        highlights.filter((h) => h && h.trim())
      );
    }
  }, [paragraph, searchTerm, filterValue]);

  if (typeof paragraph !== "string" || paragraph === null) {
    return (
      <p className={className} {...rest}>
        {paragraph}
      </p>
    );
  }

  return <p ref={paragraphRef} className={className} {...rest} dangerouslySetInnerHTML={{ __html: paragraph }}></p>;
};

export default HighlightedParagraph;
